import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { Axios } from "../../../API/Axios";
import { Pro } from "../../../API/Api";
import { useLanguage } from "../../../Context/LanguageContext";
import ProductCard from "../../../components/website/Products/ProductCard/ProductCard";
import SectionHeader from "../../../components/website/Products/ProductCard/SectionHeader";
import Skeltonshow from "../../../components/website/sekelton/skelton";
import "../../../Css/Storefront.css";

export default function SearchResults ()
{
    const { t } = useLanguage();
    const [ searchParams ] = useSearchParams();
    const query = searchParams.get( "q" ) || "";

    const [ products, setProducts ] = useState( [] );
    const [ loading, setLoading ] = useState( true );

    useEffect( () =>
    {
        if ( !query )
        {
            setProducts( [] );
            setLoading( false );
            return;
        }

        setLoading( true );
        Axios.post( `/${ Pro }/search?title=${ encodeURIComponent( query ) }` )
            .then( ( res ) =>
            {
                // بنفلتر على المنشور بس عشان مانعرضش منتجات لسه draft للزوار
                const results = ( res.data || [] ).filter( ( p ) => p.status === 'published' );
                setProducts( results );
            } )
            .catch( ( error ) => console.log( "Error searching products:", error ) )
            .finally( () => setLoading( false ) );
    }, [ query ] );

    return (
        <div className="wc-page py-5">
            <Container>
                <SectionHeader
                    title={ `${ t( 'search.resultsFor' ) } "${ query }"` }
                    subtitle={ t( 'search.subtitle' ) }
                />

                { loading ? (
                    <div className="product-grid">
                        <Skeltonshow height="300px" length="8" />
                    </div>
                ) : products.length === 0 ? (
                    <p className="text-center text-muted py-5">{ t( 'search.noResults' ) }</p>
                ) : (
                    <div className="product-grid">
                        { products.map( ( product ) => (
                            <ProductCard
                                key={ product.id }
                                id={ product.id }
                                title={ product.title }
                                description={ product.description }
                                img={ product.images && product.images[ 0 ] ? product.images[ 0 ].image : "" }
                                price={ product.price }
                                discount={ product.discount }
                                rating={ product.rating }
                                sale={ product.sale }
                            />
                        ) ) }
                    </div>
                ) }
            </Container>
        </div>
    );
}
